module.exports = __webpack_public_path__ + "img/sort.43c7e2f3.png";